<!--
 * @Description: 列表组件 可以触底刷新
 * @FilePath: packages/vue-m-comprehensive/src/components/List/index.vue
-->
<template>
  <div class="list-content">
    <slot />
    <div v-if="isNoData" class="no-data">
      <img
        :src="noDataIcon"
        alt="无数据"
        :style="{ width: noDataIconWidth, height: noDataIconHeight }"
      />
      <span :style="{ color: noDataTextColor }">{{ noDataMessage }} </span>
    </div>
    <div v-if="!!finishedText" class="nodata-bottom">
      {{ finishedText }}
    </div>
    <div v-if="!finishedText && loading" class="loading">
      <cube-loading />
    </div>
  </div>
</template>
<script>
export default {
  name: 'List',
  props: {
    // 数据是否为空
    isNoData: {
      type: Boolean,
      default: () => false,
    },
    // 数据为空时的图标
    noDataIcon: {
      type: String,
      default: () =>
        'https://staff.chunyu.mobi/@/media/images/2021/12/22/4510/29fccc141f91_w120_h80_.png',
    },
    // 数据为空时的提示语
    noDataMessage: {
      type: String,
      default: () => '',
    },
    // 没有更多数据时的地步提示语
    finishedText: {
      type: String,
      default: () => '',
    },
    // 滚动区域挂载的元素id
    mountElement: {
      type: String,
      default: () => '',
    },
    // 无限滚动等待加载
    loading: {
      type: Boolean,
      default: () => false,
    },
    noDataTextColor: {
      type: String,
      default: '#949494',
    },
    noDataIconWidth: {
      type: String,
      default: '120px',
    },
    noDataIconHeight: {
      type: String,
      default: '80px',
    },
  },
  created() {
    window.addEventListener(
      'scroll',
      e => {
        this.loadMore(e);
      },
      true
    );
  },
  methods: {
    /**
     * 触底后执行onLoad自定义事件
     *
     * @param {object} e 事件对象
     */
    loadMore(e) {
      const { scrollTop, scrollHeight, offsetHeight } = e.target;
      const buffer = 1;
      // 在一个固定区域内滚动的元素触底事件
      if (scrollTop || scrollHeight || offsetHeight) {
        if (scrollTop + offsetHeight + buffer >= scrollHeight) {
          this.$emit('onLoad');
        }
        return;
      }
      // 外部滚动的元素触底事件
      const scrollTopdom =
        document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight; // 变量windowHeight是可视区的高度
      const scrollHeightdom = // 变量scrollHeight是滚动条的总高度
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 滚动条到底部的条件
      if (scrollTopdom + windowHeight === scrollHeightdom) {
        // console.log(scrollTopdom, windowHeight, scrollHeightdom);
        this.$emit('onLoad');
      }
    },
    initStatus(scroll) {
      // console.log(scroll, 'scroll');
      const ele = document.getElementById(this.mountElement);
      if (ele) {
        ele.scrollTop = scroll || 0;
        return;
      }
      if (document.documentElement.scrollTop) {
        document.documentElement.scrollTop = 0;
        return;
      }
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.list-content {
  width: 100%;
  min-height: 100%;
  padding-top: rem(4);
  overflow-x: hidden;
}
.nodata-bottom {
  padding: rem(10);
  color: #949494;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0;
  text-align: center;
}
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-top: rem(90);
  img {
    width: rem(120);
    height: rem(80);
    margin-bottom: rem(10);
  }
  span {
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0;
  }
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: rem(20);
}
</style>
